import { Axios } from "@/plugins";

export default {
  // scheduleId = scheduleName
  // userId = email
  // projectId = projectName+email
  getByProjectId: (params) => {


    const { projectId,offset,size,type } = params;
    return Axios.get(
      `/projects/${projectId}/schedules`,{
        params:{
          offset,size,type
        }
      }
    );
  },
  getScheduleItems: (params) => {


    const { project_id,scheduleName,version } = params;
    return Axios.get(
      `/project/${project_id}/schedule/${scheduleName}/version/${version}/item`,{
        params:{
          ...params.query
        }
      }
    );
  },
  getScheduleLevels: (params) => {


    const { project_id,scheduleName,version } = params;
    return Axios.get(
      `/project/${project_id}/schedule/${scheduleName}/version/${version}/level`
    );
  },
  getCollaboratorsList: (params) => {


    const { projectId,scheduleId,offset,size} = params;
    return Axios.get(
      `projects/${projectId}/schedules/${scheduleId}/users`,{
        params:{
          offset,size
        }
      }
    );
  },
  linktoScheduler: (params) => {


    const { projectId,scheduleId,email} = params;
    return Axios.post(
      `projects/${projectId}/schedules/${scheduleId}/users/${email}`
    );
  },
  deleteSchedule: (params) => {


    const { projectId,scheduleId, email} = params;
    return Axios.delete(
      `/projects/${projectId}/schedules/${scheduleId}/users/${email}`
    );
  },
  getSchedules: (params) => {

    const {project_id,page,size} = params;
    return Axios.get(
      `/project/${project_id}/schedule`,{
        params:{
          page,size
        }
      }
    );
  },

  createSchedule: (payload) => {
    const { schedule_name,project_id} = payload;
    return Axios.post(`/project/${project_id}/schedule`, {
    
      schedule_name:schedule_name,
      
    });
  },
  editSchedule: (payload) => {
    const { scheduleName,project_id,updateScheduleName} = payload;
    return Axios.put(`/project/${project_id}/schedule/${scheduleName}`, {
      data: {
        name: updateScheduleName,
      },
    });
  },
  createScheduleItem:(payload)=>{
    const { scheduleName,project_id,version} = payload;
    return Axios.post(`/project/${project_id}/schedule/${scheduleName}/version/${version}/item`, {
    
      ...payload.body
      
    });
    
  },

  createScheduleVersion: (payload) => {
    const { scheduleName,project_id,version,RFQ} = payload;
    return Axios.post(`/project/${project_id}/schedule/${scheduleName}/publish`, {
    
      version:version,
      RFQ:RFQ
    });
  },
  editScheduleVersion: (payload) => {
    const { scheduleName,project_id,version,URN} = payload;
    return Axios.put(`project/${project_id}/schedule/${scheduleName}/version/${version}/urn`, {
      URN:URN
    }
    );
  }
};
